
import $ from "jquery";

export default class Util {
    static getModuleName () {
        return document.body.getAttribute('module');
    }

    static scrollBottom(callback,scrollHeightCallback){

        window.addEventListener("scroll",function(e){

            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            if(document.documentElement.scrollHeight == document.documentElement.clientHeight + scrollTop ) {
                callback();
            }
            if (scrollHeightCallback){
                scrollHeightCallback(document.documentElement.offsetHeight-scrollTop-windowHeight);
            }
        });
    }

    static isSupWebP() {
        try{
            return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
        } catch (e) {
            return false;
        }
    }

    static isMobile(){
        if(/Android|webOS|iPhone|Windows Phone|iPod|BlackBerry|SymbianOS/i.test(navigator.userAgent)){
            return true;
        }
        return false;
    }

    /**
     * qs 包在Android低版本会报错
     * @param arrObj
     */
    static buildQuery( arrObj ){
        let ret = [];
        for(var x in arrObj){
            ret.push(x + "=" + encodeURI(arrObj[x]));
        }
        return ret.join('&');
    }

    static globalEvents(){
        //trigger like
        $('.js-cm-like').click(function(){
            var id = $(this).attr('data-id');
            $.getJSON("/photos/likeComment/?id=" + id);
            $(this).html('已赞').removeClass('js-cm-like');
        });
    }

    static commentHandler( pageCfg ){

        function sendComment(id , module ){
            $.post("/comment/post/?ajax=1",{
                dataId : id,
                module : module,
                content : $('#cmtPost'+id).val()
            },function(data){
                if (!data.success){
                    alert(data.msg);return;
                }
                alert('评论发布成功！');
            },'JSON');
        }

        if ($('.js-post-cmt').length > 0){
            document.onkeydown = function(event) {
                if (event.ctrlKey && event.keyCode == 13) {
                    sendComment( pageCfg.dataId , pageCfg.module );
                }
            }
            $('.js-post-cmt-btn').click(function(){
                sendComment(pageCfg.dataId , pageCfg.module );
            });
        }
    }

    static removeItemFromArray( frmArray , val ){

        var index = frmArray.indexOf(val);
        if (index > -1) {
            frmArray.splice(index, 1);
        }
        return frmArray;
    }
}



// WEBPACK FOOTER //
// ./src/lib/util.js